import React from "react";
import FormFunc from "../../../utils/FormFunc";
import Feature from "../../../utils/Feature";
import { useInfo } from "context/InfoContext";
import UserInfoPhotoUpload from "../UserInfoPhotoUpload";
import { Button } from "react-materialize";

export default function EmpInfoContent({ boxName, userData, handleEvents }) {
  const { filters, filterData, isReactivated } = useInfo();
  // console.log("userData=>", userData);
  // console.log("filters=>", filters.photo);
  let addClass = "col s4";
  const isCannotEdit =
    userData?.user_sess?.userCanAccessHrAssign || userData?.user_sess?.isAdmin
      ? false
      : true;
  const isCannotEditEmail =
    filters?.idu === undefined ||
    ((userData?.user_sess?.userCanAccessHrAssign ||
      userData?.user_sess?.isAdmin) &&
      isReactivated)
      ? false
      : true;
  const isYourProfile = userData?.idu === filters?.idu ? true : false;
  return (
    <div key={"info-content-" + boxName + "-" + filters.key_form}>
      <UserInfoPhotoUpload
        filters={filters}
        boxName={boxName}
        isCannotEdit={isCannotEdit}
        isYourProfile={isYourProfile}
        handleEvents={handleEvents}
      />
      {filters?.current_active === "N" && (
        <div className={boxName + " row"} style={{ marginTop: "15px" }}>
          <span
            style={{
              fontSize: "13px",
              display: "inline-block",
              color: "#c01313",
              paddingLeft: "6px",
              marginBottom: "10px",
            }}
          >
            * The email address can be edited upon reactivating the status or
            changing it from 'Inactive' to 'Active'
          </span>
          {!isReactivated && (
            <Button
              className="blue"
              id="btn-reactivate"
              node="button"
              waves="light"
              onClick={handleEvents.OnReactivate}
              style={{
                borderRadius: "12px",
                fontSize: "13px",
                height: "25px",
                lineHeight: "23px",
                marginLeft: "12px",
                display: "inline-block",
                marginTop: "-5px",
              }}
            >
              Set to Active
            </Button>
          )}
        </div>
      )}
      <div className={boxName + " row"} style={{ marginTop: "15px" }}>
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "title",
            label: "Title*",
            options: filterData.data.titles,
            addClass: "col s3",
            defaultValue: filters?.title ?? "",
            required: true,
            disabled: isCannotEdit && isYourProfile ? false : isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "fname",
            label: "First Name*",
            addClass: "col s3",
            defaultValue: filters?.fname ?? "",
            required: true,
            disabled: isCannotEdit && isYourProfile ? false : isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "lname",
            label: "Last Name*",
            addClass: "col s3",
            defaultValue: filters?.lname ?? "",
            required: true,
            disabled: isCannotEdit && isYourProfile ? false : isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "nickname",
            label: "Nick Name*",
            addClass: "col s3",
            defaultValue: filters?.nickname ?? "",
            required: true,
            disabled: isCannotEdit && isYourProfile ? false : isCannotEdit,
          }}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"}>
        <FormFunc.InputText
          data={{
            name: "email",
            label: "Work Email*",
            addClass: addClass + (isCannotEditEmail ? " disable" : ""),
            value: filters?.email ?? "",
            // defaultValue: filters?.email ?? "",
            required: true,
            disabled: isCannotEditEmail,
          }}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "position",
            label: "Position*",
            addClass: addClass,
            defaultValue: filters?.position ?? "",
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "job_class",
            label: "Job Class*",
            options: filterData.data.jobclasses,
            addClass: addClass,
            optionName: "class_name",
            optionValue: "class_id",
            optionTitle: "---",
            defaultValue: filters?.job_class ?? "",
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"} style={{ marginBottom: "15px" }}>
        <FormFunc.SingleSelect
          data={{
            name: "job_type",
            label: "Job Type*",
            options: filterData.data.jobfunctions,
            addClass: addClass,
            optionName: "job_name",
            optionValue: "job_id",
            optionTitle: "---",
            defaultValue: filters?.job_type ?? "",
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "country",
            label: "Employed By*",
            options:
              /*Feature.GetCountryByPermission(
              filterData.data.countries,
              userData
            )*/ filterData.data.countries,
            addClass: addClass,
            optionName: "country_name",
            optionValue: "country_code",
            optionTitle: "---",
            defaultValue: filters?.country ?? "",
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "work_country",
            label: "Work Country*",
            options: Feature.GetCountryExcludeEXOGroup(
              filterData.data.workcountries
            ),
            addClass: addClass,
            optionName: "country_name",
            optionValue: "country_code",
            optionTitle: "---",
            defaultValue: filters?.work_country ?? "",
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"} style={{ marginBottom: "15px" }}>
        <FormFunc.SingleSelect
          data={{
            name: "work_city",
            label: "Work City*",
            options: Feature.GetDataRelateCountry(
              filterData.data.locations,
              filters,
              ["work_country"]
            ),
            addClass: addClass,
            optionName: "city",
            optionValue: "city",
            optionGroup: true,
            optionTitle: "---",
            defaultValue: filters?.work_city ?? "",
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.MultiSelect
          data={{
            name: "organization",
            label: "Organization*",
            // options: Feature.GetDataRelateCountry(
            //   filterData.data.organizations,
            //   filters,
            //   ["country", "work_country"]
            // ),
            options: filterData?.data?.organizations,
            addClass: addClass,
            optionName: "org_name",
            optionValue: "org_id",
            optionGroup: true,
            optionTitle: "---",
            defaultValue: filters?.organization ?? [],
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.MultiSelect
          data={{
            name: "branch",
            label: "Branch",
            options: Feature.GetOptionBranchs(
              filterData.data.branches,
              filters?.organization
            ),
            addClass: addClass,
            optionName: "org_name",
            optionValue: "org_id",
            optionGroup: true,
            optionTitle: "---",
            defaultValue: filters?.branch ?? [],
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"} style={{ paddingBottom: "15px" }}>
        <FormFunc.MultiSelect
          data={{
            name: "department",
            label: "Department*",
            options: Feature.GetOptionDepartments(
              filterData.data.departments,
              filters?.organization
            ),
            addClass: addClass,
            optionName:
              filters?.organization?.length > 1 ? "display_name" : "dept_name",
            optionValue: "dept_id",
            optionGroup: true,
            optionTitle: "---",
            defaultValue: filters?.department ?? [],
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.MultiSelect
          data={{
            name: "division",
            label: "Division",
            options: Feature.GetOptionDivisions(
              filterData.data.divisions,
              filters?.department
            ),
            addClass: addClass,
            optionName: "dept_name",
            optionValue: "dept_id",
            optionGroup: true,
            optionTitle: "---",
            defaultValue: filters?.division ?? [],
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "is_expatriate",
            label: "Is Expatriate",
            options: filterData.data.yesno,
            addClass: addClass,
            defaultValue: filters?.is_expatriate ?? "no",
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
      </div>
    </div>
  );
}
